import { functions } from '../../firebase';

export async function fetchShopJobsWithTechs() {
    const { data } = await functions.httpsCallable('fetchShopJobsWithTechs')();
    return Array.isArray(data) ? data : [];
}
